<template>
    <v-ons-page>
        <v-ons-toolbar ref="ref_toolbar">
            <div class="left">
                <v-ons-back-button>戻る</v-ons-back-button>
            </div>
            <div class="center">このアプリについて</div>
        </v-ons-toolbar>

        <div class="contents">
            <h1>PSO2 Ability Coordinator</h1>

            <p style="text-align: left;">
                PSO2用の特殊能力値簡易計算機のようなものです。<br/>
                シミュレーターではありませんので合成とか素材逆引きとかはできません。<br/>
                <!--せいぜい電車の中で「次の報酬機関でどんな武器防具作ろうかなー」とか考えるのに使えるかもしれない程度のものです。<br/>-->
                特殊能力の組み合わせに悩んだときなどにご利用ください。<br/>
                <br/>
                <br/>
                ver.0.0.3<br/>
                終了時の状態を保存するように修正<br/>
                <br/>
                <br/>
                &copy; Rochefort<br/>
                &copy; SEGA<br/>
                『PHANTASY STAR ONLINE 2』公式サイト<br/>
                <a href="http://pso2.jp/" target="_blank">http://pso2.jp/</a>
            </p>
        </div>

        <!--<adsense-->
            <!--ad-client="ca-pub-1427949208553779"-->
            <!--ad-slot="★2"-->
            <!--ad-style="display: block"-->
            <!--ad-format="auto">-->
        <!--</adsense>-->
    </v-ons-page>
</template>

<script>
export default {
    name: "AboutApp",
    created() {
        this.$ga.page('/AboutApp')
    },
}
</script>

<style scoped>
    p {
        margin: 5vw;
        text-align: left;
    }
</style>
